module.exports = __webpack_public_path__ + "img/IT0000162756956.9785bc02.png";